import React from 'react';
import H from '../elements/H';
import { IMTTripReservingDetails } from '../../integrations/erp/apiTypes';
import { t } from '../../utils/i18n';

interface TripPricingInformationProps {
  tripReservationData: IMTTripReservingDetails;
}

// TODO: How about one day trips with no over night stay?
const durationNightTexts = {
  single: t('yö alkaen'),
  multiple: t('yötä alkaen')
};

const TripPricingInformation: React.FunctionComponent<
  TripPricingInformationProps & React.HTMLAttributes<HTMLElement>
> = ({ tripReservationData }) => {
  const { durationAsNights, pricePerPassenger } = tripReservationData;

  return (
    <div
      className="trip-pricing-information"
      data-testid="trip-pricing-information"
    >
      <H styling="h3" data-testid="trip-duration">
        <strong>
          {durationAsNights}{' '}
          {t(
            durationNightTexts.single,
            durationNightTexts.multiple,
            durationAsNights > 1
          )}
        </strong>
      </H>
      <div data-testid="price-per-passenger">
        <H styling="h1" tag="div">
          <strong>
            {pricePerPassenger} {t('€ / henkilö')}
          </strong>
        </H>
      </div>
    </div>
  );
};

export default TripPricingInformation;
